"use client"
import styled from "@emotion/styled"
import {
  Attribute,
  LocatorStationsWrapper
} from "api"
import { useLocale } from "next-intl"

import {
  CustomBreadcrumbs,
  HomeIcon,
  TitleWithLine,
  useIsDesktop
} from "ui"
import LocatorMap from "./LocatorMap"

const StyledContainer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`

const StyledCont = styled.div<{ noPaddingBottom: boolean, noPaddingTop: boolean }>`
  padding-bottom: ${(props) => (props.noPaddingBottom ? '0px' : '168px')};
  padding-top: ${(props) => (props.noPaddingBottom ? '0px' : '36px')};
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export type LocatorProps = {
  metadata: Attribute[]
  stations: LocatorStationsWrapper
  isPazCharge: boolean
  withoutBreadCrumbs: boolean
  noPaddingBottom: boolean
  noPaddingTop: boolean
}

export interface UserLocation {
  lat: number;
  lon: number;
}

function Locator({ metadata, stations, isPazCharge, withoutBreadCrumbs, noPaddingBottom, noPaddingTop }: LocatorProps) {

  const locale = useLocale()
  const isDesktop = useIsDesktop()

  return (
    <StyledContainer>
      {!withoutBreadCrumbs &&
        <CustomBreadcrumbs
          locale={locale}
          current={{
            title: locale === "en" ? "Locator" : "איתור תחנות ושרותים",
            url: `/`,
          }}
          parents={[{ title: <HomeIcon />, url: "/" }]}
        />
      }

      <StyledCont
        noPaddingTop={noPaddingTop}
        noPaddingBottom={noPaddingBottom}
      >
        {!isPazCharge &&
          <TitleWithLine
            title="איתור תחנות ושירותים"
            titleColor="#000"
            largeDesktopLineHeight="76.8px"
            largeDesktopFontSize={64}
            titleFontSize={42}
            desktopLineHeight="50.4px"
            noPadding
            marginLeft={isDesktop ? 0 : 16}
          />
        }
        <LocatorMap
          {...{ metadata, stations, isPazCharge, withoutBreadCrumbs }}
        />
      </StyledCont>
    </StyledContainer>
  )
}

export default function LocatorWrapper(props: LocatorProps) {
  return (
    <Locator {...props} />
  )
}
